export default function DefaultButton({ onClick }) {
  return (
    <button
      className="btn btn-light"
      onClick={onClick}
      id="default-bound"
      aria-label="Reset map to default view"
      type="button"
    >
      Default
    </button>
  );
}
